const tr = {
  medical_record_evolutions:{
    attributes:{
      id:                       'ID',
      owner:                    'Preenchido por',
      user_id:                  'Paciente',
      medical_record_id:        'Prontuário',
      medical_record:           'Prontuário',
      user:                     'Paciente',
      notes:                    'Evolução',
      date:                     'Data',
      created_at:               'Criado em',
      updated_at:               'Atualizado em',
      files:                    'Anexos',
    },
    extras:{
      create_evolution: 'Nova evolução',
      edit_evolution: 'Editar evolução',
      not_permission_show: 'Você não possui permissão para visualizar está evolução',
      noFiles: 'Não possui anexos vinculados',
      save_fail: 'Não foi possível salvar os anexos vinculados',
      show_file: 'Visualizando anexo',
    },
  }
};

export default tr;
